<template>
  <div class="demo">
    <SjPaginationTable
      async
      fullContainer
      :data="data"
      :columns="columns"
      @getData="handleGetData"
      :total="100"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      columns: [
        {
          prop: "name",
          label: "名称",
          align: "center",
          width: 100
        },
        {
          prop: "row1",
          label: "列1"
        },
        {
          prop: "row2",
          label: "列2"
        },
        {
          prop: "row3",
          label: "列3",
          sortable: true
        }
      ]
    };
  },
  methods: {
    handleGetData(pageIndex, sortConfig) {
      this.data = Array.from({ length: 10 }).map((item, index) => ({
        name: `列${(pageIndex - 1) * 10 + 1 + index}`,
        row1: `row1_${(pageIndex - 1) * 10 + 1 + index}`,
        row2: `row2_${(pageIndex - 1) * 10 + 1 + index}`,
        row3: `${(sortConfig || "") && (sortConfig.order || "")}${(pageIndex -
          1) *
          10 +
          1 +
          index}`
      }));
    }
  }
};
</script>

<style scoped lang="less">
.demo {
  height: 350px;
}
</style>
